// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import _ from "lodash";
import React, { RefObject } from "react";
import { connect } from "react-redux";
//import { RouteComponentProps } from "react-router-dom";
import { RouteComponentProps, Link } from "react-router-dom";
import SplitPane from "react-split-pane";
import { bindActionCreators } from "redux";
import { PrimaryButton } from "@fluentui/react";
import HtmlFileReader from "../../../../common/htmlFileReader";
import { strings, interpolate } from "../../../../common/strings";
import {
    AssetState, AssetType, EditorMode, FieldType,
    IApplicationState, IAppSettings, IAsset, IAssetMetadata,
    ILabel, IProject, IRegion, ISize, ITag, FeatureCategory, FieldFormat,
    IAuthenticationState, IAzureFields
} from "../../../../models/applicationState";
import IApplicationActions, * as applicationActions from "../../../../redux/actions/applicationActions";
import IProjectActions, * as projectActions from "../../../../redux/actions/projectActions";
import IAppTitleActions, * as appTitleActions from "../../../../redux/actions/appTitleActions";
import { AssetPreview, ContentSource } from "../../common/assetPreviewFR/assetPreview";
import { KeyboardBinding } from "../../common/keyboardBinding/keyboardBinding";
import { KeyEventType } from "../../common/keyboardManager/keyboardManager";
import { TagInput } from "../../common/tagInputFR/tagInput";
import { tagIndexKeys } from "../../common/tagInputFR/tagIndexKeys";
import { TableView } from "../operations/tableView"
import CanvasHelpers from "../operations/canvasHelpers";
import "../operations/editorPage.scss";
import EditorSideBarN from "../operations/EditorSideBarN";
import Alert from "../../common/alert/alert";
import Confirm from "../../common/confirm/confirm";
import { OCRService } from "../../../../services/ocrService";
import { throttle } from "../../../../common/utils";
import { constants } from "../../../../common/constants";
import PreventLeaving from "../../common/preventLeaving/preventLeaving";
import { Spinner, SpinnerSize } from "@fluentui/react/lib/Spinner";
import { getPrimaryGreenTheme, getPrimaryRedTheme } from "../../../../common/themes";
import { toast } from "react-toastify";
import { PredictService } from "../../../../services/PredictService";
import { AssetService } from "../../../../services/assetService";
import BeforeUnloadComponent from "react-beforeunload-component";
import { SkipButton } from "../../shell/skipButton";
import ModalHeader from "../header/subHeader";
import ODModalHeader from "../header/ODsubHeader";
import HeaderComponent from "../header/header";
import size from "lodash/size";
import { StatusBar } from "../../shell/statusBar";
import { StatusBarMetrics } from "../../shell/statusBarMetrics";
import OperationsHeader from "../header/operationsSubHeader";
import IUserOperationsActions, * as userOperationsActions from "../../../../redux/actions/operationsActions";
import Canvas from "../operations/canvas_editTags";
import { documentMangementTagsSave, headers,documentMangementTagsException, accessToken } from "../../../../common/api-config";
import axios from "axios";
import Select from "react-select";
import DocViewer from "./docViewer";
import moment from "moment";
import { SplitView } from "./SplitView";

/**
 * Properties for Editor Page
 * @member project - Project being edited
 * @member recentProjects - Array of projects recently viewed/edited
 * @member actions - Project actions
 * @member applicationActions - Application setting actions
 */
export interface IDocumentEditTagsProps extends RouteComponentProps, React.Props<DocumentEditTags> {
    project: IProject;
    recentProjects: IProject[];
    appSettings: IAppSettings;
    actions: IProjectActions;
    applicationActions: IApplicationActions;
    appTitleActions: IAppTitleActions;
    loggedInUser: IAuthenticationState;
    loadAnnotateFiles: IAsset[];
    userOperationsActions: IUserOperationsActions;

}

/**
 * State for Editor Page
 */
export interface IDocumentEditTagsState {
    /** Array of assets in project */
    assets: IAsset[];
    /** The editor mode to set for canvas tools */
    editorMode: EditorMode;
    /** The selected asset for the primary editing experience */
    selectedAsset?: IAssetMetadata;
    /** Currently selected region on current asset */
    selectedRegions?: IRegion[];
    /** Most recently selected tag */
    selectedTag: string;
    /** Tags locked for region labeling */
    lockedTags: string[];
    /** Size of the asset thumbnails to display in the side bar */
    thumbnailSize: ISize;
    /**
     * Whether or not the editor is in a valid state
     * State is invalid when a region has not been tagged
     */
    isValid: boolean;
    /** Whether the show invalid region warning alert should display */
    showInvalidRegionWarning: boolean;
    /** Show tags when loaded */
    tagsLoaded: boolean;
    /** The currently hovered TagInputItemLabel */
    hoveredLabel: ILabel;
    /** Whether the task for loading all OCRs is running */
    isRunningOCRs?: boolean;
    /** Whether OCR is running in the main canvas */
    isCanvasRunningOCR?: boolean;
    isCanvasRunningAutoLabeling?: boolean;
    isError?: boolean;
    errorTitle?: string;
    errorMessage?: string;
    tableToView: object;
    tableToViewId: string;
    selectedOcrFile: any;
    selectedProject: any;
    submitted: boolean;
    analyzeResult: any;
    selectedDType:any;

    userId: string;
    project: IProject;
    tagsInfo: any;
    iseTagSelected: boolean;
    eTagSelectedId: string;
    eTagSelectedVal: string;
    newTagValue: string;
    tableHeaders:any;
    pdfResp:any;
    selectedDocument:any;
    fileName:string;
    customer:string;
    imageUrl:string;
    tagsShow:boolean;
    associationHeader:any;
    resp:any;
    aresp:string;
    exceptionKeyList:any;
    arespImage:any;
}

function mapStateToProps(state: IApplicationState) {
    return {
        recentProjects: state.recentProjects,
        project: state.currentProject,
        appSettings: state.appSettings,
        loggedInUser: state.loggedInUser,
        loadAnnotateFiles: state.loadAllFiles,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(projectActions, dispatch),
        applicationActions: bindActionCreators(applicationActions, dispatch),
        appTitleActions: bindActionCreators(appTitleActions, dispatch),
        userOperationsActions: bindActionCreators(userOperationsActions, dispatch),

    };
}

/**
 * @name - Editor Page
 * @description - Page for adding/editing/removing tags to assets
 */
@connect(mapStateToProps, mapDispatchToProps)
export default class DocumentEditTags  extends React.Component<IDocumentEditTagsProps, IDocumentEditTagsState>{
    public state: IDocumentEditTagsState  = {
        selectedTag: null,
        lockedTags: [],
        assets: [],
        editorMode: EditorMode.Select,
        thumbnailSize: { width: 175, height: 155 },
        isValid: true,
        showInvalidRegionWarning: false,
        tagsLoaded: false,
        hoveredLabel: null,
        tableToView: null,
        tableToViewId: null,
        selectedOcrFile: null,
        selectedProject: "",
        submitted: false,
        analyzeResult: null,
        userId: null,
        project: null,
        tagsInfo: [],
        iseTagSelected: false,
        eTagSelectedId: "",
        eTagSelectedVal: "",
        newTagValue: "",
        tableHeaders:[],
        pdfResp:null,
        selectedDocument:null,
        fileName:'',
        customer:'',
        imageUrl:"",
        tagsShow:true,
        associationHeader:[],
        selectedDType:null,
        resp:null,
        aresp:null,
        exceptionKeyList:[],
        arespImage:null,
    };
    private selectedDocument: any;
    TagsInfo = []
    private tagInputRef: RefObject<TagInput>;

    private loadingProjectAssets: boolean = false;
    private canvas: RefObject<Canvas> = React.createRef();
    private renameTagConfirm: React.RefObject<Confirm> = React.createRef();
    private renameCanceled: () => void;
    private deleteTagConfirm: React.RefObject<Confirm> = React.createRef();
    private deleteDocumentConfirm: React.RefObject<Confirm> = React.createRef();
    private isUnmount: boolean = false;
    private selectedInvalidFile: any;
    private path: any;
    selectedProject = ""
    private tag_folders = ['2630-9', 'certificateof-origin', "china-long-form-9295", "health-certificate", "Invalid", "invoice", "lab-results", "manifest-summary", "no-wood",
        "obl-hmm", "obl-hmm-1", "obl-oneobl", "ocean-bill-of-lading", "order-confirmation", "packing-list", "picture-of-cases", "picture-of-seal", "racto-letter"]


    constructor(props) { 
        super(props);
        this.tagInputRef = React.createRef();
        this.setState({ selectedProject: "", submitted: false });      

        
        this.handleChange = this.handleChange.bind(this);
    }
    private getSchema = (event) => {

        console.log(event)
        if (event) {
            this.setState({ selectedDType: event });
        } else {
            this.setState({ selectedDType: null });
        }
    }
    getPdfurl(){
        let selectedDocument = JSON.parse(localStorage.getItem("selectedDocument"));
        console.log(selectedDocument)
        let finalImageUrl = selectedDocument['Attachment_SAS_Url'];
        //  + "?sv=2019-12-12&ss=bfqt&srt=sco&sp=rwdlacupx&se=2031-02-02T19:05:57Z&st=2021-02-02T11:05:57Z&spr=https&sig=Fk86kRiOT8lI3KJt%2Bk9UkltfwYZ1hQ%2FCoxlzJFiTe2I%3D"

        return finalImageUrl;
    }

    
    public getaImage(){
       
       // debugger;
        let selectedDocument = JSON.parse(localStorage.getItem("selectedDocument"));
        console.log(selectedDocument['Attachment_SAS_Url'],"selectedDocument['Attachment_SAS_Url']");
        
        
       // const url1 ="https://stchepdcapdev001.blob.core.windows.net/chep/CURATED/2021-08-11T12-02-0300-00-212832_attachment_RetestT58-1NotcleanAug9.xlsx?sv=2019-12-12&ss=bfqt&srt=sco&sp=rwdlacupx&se=2031-02-02T19:05:57Z&st=2021-02-02T11:05:57Z&spr=https&sig=Fk86kRiOT8lI3KJt%2Bk9UkltfwYZ1hQ%2FCoxlzJFiTe2I%3D";
        this.setState({aresp:selectedDocument['Attachment_SAS_Url']}) ;  
        
        /*
        if(selectedDocument['Attachment_SAS_Url'] != 'null' && selectedDocument['Attachment_SAS_Url']!=""){
            fetch(url1)
            .then((response) => {
              
              response.blob().then(blob => {                  
                  
                  const reader = new FileReader();
                  reader.readAsDataURL(blob);
                  reader.onloadend = () => {
                    this.setState({
                    
                      arespImage: reader.result,
                    });
                  };
 
               
                
            });
              //
              
            })
            .then((html) => {
              console.log(html,"@@@@@@@@@@@@@@@"); 
              
            });
        }else{
            this.setState({aresp:"<html><body> No email body </body></html>"}) 
        }
        
       */
     }

     public getImage(){
        // fetch('https://stchepdcapdev001.blob.core.windows.net/chep/CURATED/492021-T1020_PO50122_body_.html?sv=2019-12-12&ss=bfqt&srt=sco&sp=rwdlacupx&se=2031-02-02T19:05:57Z&st=2021-02-02T11:05:57Z&spr=https&sig=Fk86kRiOT8lI3KJt%2Bk9UkltfwYZ1hQ%2FCoxlzJFiTe2I%3D')
        // .then(response =>{
        //     this.setState({resp:response.body})
        //     console.log(response,"@@@@@@@@@@@@@@@@@@@@")
        // }
        // );
        let selectedDocument = JSON.parse(localStorage.getItem("selectedDocument"));
        console.log(selectedDocument['Body_SAS_Url'],"selectedDocument['Body_SAS_Url']")
        if(selectedDocument['Body_SAS_Url'] != 'null' && selectedDocument['Body_SAS_Url']!=""){
            fetch(selectedDocument['Body_SAS_Url'])
            .then((response) => {
              return response.text();
            })
            .then((html) => {
              console.log(html,"@@@@@@@@@@@@@@@");   
              this.setState({resp:html}) 
            });
        }else{
            this.setState({resp:"<html><body> No email body </body></html>"}) 
        }
        
        // function fetchHtml() {
           
        //   }
     }
    public async componentDidMount() { 
        window.addEventListener("focus", this.onFocused);
//debugger;
        this.getImage();
        this.getaImage();
        this.isUnmount = false;
        const user = this.props.loggedInUser;
        const userId = user.user.oid;
        this.setState({ userId });
        let customer = localStorage.getItem("Customer");
        let fileName = localStorage.getItem("fileName");
        let selectedDocument = JSON.parse(localStorage.getItem("selectedDocument"));
       
        console.log(selectedDocument)
        let finalImageUrl = selectedDocument['Attachment_SAS_Url'];
        this.setState({ selectedDType:  { value: 'email', label: 'Email Body' } });
        // '] + "?sv=2019-10-10&ss=bfqt&srt=sco&sp=rwdlacupx&se=2030-07-13T23:43:36Z&st=2020-07-13T15:43:36Z&spr=https&sig=wfqsJ4ekq78VnUG07q45YLKjBbTaZUB3S%2F%2BmppSlX1g%3D#toolbar=0"
        this.setState({imageUrl:finalImageUrl});
        // let tagsInfo = JSON.parse(selectedDocument.Tagsinfo);
        // console.log(tagsInfo,"@@@@@@@@@@@@@@@@@@@@@@")
        let tagsKeyValues =[];
        for (const [key, value] of Object.entries(selectedDocument)) {
            if(key!= "Attachment_SAS_Url" && key!="Body_SAS_Url"){
                tagsKeyValues.push({
                    key:key,
                    value:value
                })
            }
            
          }
        this.setState({
            tableHeaders:tagsKeyValues, 
            customer: customer,
            fileName:fileName,
            selectedDocument:selectedDocument,
            // tagsInfo: tagsInfo,
            associationHeader:[]
           
        })

        console.log(this.state.selectedDocument)

        const projectname = "invoice_w_po_D";
        const connection = { id: null, name: null, providerType: "azureBlobStorage", providerOptions: {} };
        connection.providerOptions["sas"] = IAzureFields.sasUrl;

        const project: IProject = {
            id: "",
            name: projectname,
            version: "",
            securityToken: "token",
            tags: [],
            sourceConnection: connection,
            lastVisitedAssetId: "",
            tableTags: [],
            fromModel: true,
            apiUriBase: IAzureFields.endPoint,
            apiKey: IAzureFields.key,
            folderPath: `${projectname}-${this.state.userId}}/training`,
            projType: "ocr", //model.type.toLocaleLowerCase(),
            assets: {},
            predictModelId: "",
            analyzeResult: [],
            exportFormat: null,
            activeLearningSettings: null,
            autoSave: false,
            targetConnection: null,
            videoSettings: null,
            isProjectExported: false,
            isProjectSaved: false,
        };
        this.setState({ project: project,tableHeaders:tagsKeyValues});
        await this.loadProjectAssets();
        // this.getFilesFromBlob();
        document.title = strings.editorPage.title + " - " + strings.appName;
    }

    public getFilesFromBlob = () => {
        const projectCopy = Object.assign({}, this.state.project);
        projectCopy.folderPath = `${projectCopy.name}-${this.state.userId}/training`;
        this.props.actions.loadBlobs(projectCopy, "FailedProcess");
    }


    public async componentDidUpdate(prevProps: Readonly<IDocumentEditTagsProps>, prevState) {
        if (this.props.project) {
            if (this.state.assets.length === 0) {
                await this.loadProjectAssets();
            } else {
                this.updateAssetsState();
            }
        }
        const { project } = this.props;
        if (this.props.loadAnnotateFiles !== prevProps.loadAnnotateFiles) {
            await this.loadProjectAssets();
        } else {
            localStorage.setItem("filesLengthFromModel", prevProps.loadAnnotateFiles.length.toString())
        }
      
    }

    public componentWillUnmount() {
        this.isUnmount = true;
        window.removeEventListener("focus", this.onFocused);
        this.abortController.abort();
    }

    //componentWillUnmount = () => this.abortController.abort();

    abortController = new window.AbortController();

    public render() {
        //const { project } = this.props;
        let selectedDocument = JSON.parse(localStorage.getItem("selectedDocument"));
        console.log(selectedDocument);
        let finalImageUrl = selectedDocument['Attachment_SAS_Url'];
        let excelfile = finalImageUrl?finalImageUrl:"";
        let isExcel=false;
         
        if(excelfile.indexOf(".xlsx")>-1) 
        {           
            isExcel =true;
           
        }        
        if(excelfile.indexOf(".xls")>-1) 
        {           
            isExcel =true;           
        }        
        if(excelfile.indexOf(".html")>-1) 
        {
           
            isExcel =true;
           
        }
        const project = this.state.project;
        const { assets, selectedAsset, isRunningOCRs, isCanvasRunningOCR, isCanvasRunningAutoLabeling, tagsInfo } = this.state;

        const labels = (selectedAsset &&
            selectedAsset.labelData &&
            selectedAsset.labelData.labels) || [];

        // console.log("selected asset==>"+JSON.stringify(selectedAsset));
        const needRunOCRButton = assets.some((asset) => asset.state === AssetState.NotVisited);

        // if (!project) {
        //     return (<div className="text-center mt-5">Loading...</div>);
        // }
        // else
        
            const routeUrl = `/upload-files/${this.props.match.params["projectName"]}/${this.props.match.params["schema"]}/ocr/${this.props.match.params["projectId"]}`;

            const options = [
                { value: 'email', label: 'Email Body' },
                { value: 'attachment', label: 'Attachments' },
              
               
            ];
            
          

            return (

                <>
                    <HeaderComponent
                        history={this.props.history}
                        match={this.props.match}
                        location={this.props.location} />

                    {/* <OperationsHeader propsMatch={this.props.match} /> */}
                    <div className="editor-page skipToMainContent" id="pageEditor">
{
/*
                        <BeforeUnloadComponent
                            alertMessage='Are you sure you want to leave? Changes will not be saved.'
                        >
*/}
                            {this.state.tableToView !== null &&
                                <TableView
                                    handleTableViewClose={this.handleTableViewClose}
                                    tableToView={this.state.tableToView}
                                />
                            }
                            {
                                tagIndexKeys.map((index) =>
                                (<KeyboardBinding
                                    displayName={strings.editorPage.tags.hotKey.apply}
                                    key={index}
                                    keyEventType={KeyEventType.KeyDown}
                                    accelerators={[`${index}`]}
                                    icon={"fa-tag"}
                                    handler={this.handleTagHotKey} />))
                            }
      
                                        
                                      <div onClick={this.onPageClick}  className="fwidth">                                         
                                      { /* 
                                <SplitPane split="vertical"
                                    primary="second"
                                    maxSize={500}
                                    minSize={500}
                                    pane1Style={{ height: "100%", width: "50%" }}
                                    pane2Style={{ height: "auto", width: "50%" }}
                                    resizerStyle={{ width: "5px", margin: "0px", border: "2px", background: "transparent" }}
                                    onChange={() => this.resizeCanvas()}>
                                         */}
                                   <div className="SpApp fwidth">  
                              <SplitView 
          left={<div style={{ margin: "1rem" }}> 
              <div className="editor-page-content1" id="lPanel" >
                                <div style={{ height:'100%'}}>
                              <table style={{width:'100%'}}  > <tr><td>
                                
                                
                                <div style={{display: 'inline-flex', marginTop:'5px'}}>
                                                <span style={{marginTop:'5px'}}>Select Document</span> &nbsp; &nbsp; <span style={{width:'200px'}}>
                                                
                                                           
                                                    
                            <Select options={options}
                              value={this.state.selectedDType}
                              onChange={this.getSchema}
                              className="react-select-container z-index-19"
                              isClearable={false}
                              placeholder="AI Models"
                              theme={(theme) => ({
                                ...theme,
                                colors: {
                                  ...theme.colors,
                                  primary25: "#161a1f",
                                  primary: "#6b727d",
                                  neutral0: "#222830",
                                  neutral20: "#44474c",
                                  neutral30: "#272c33",
                                  neutral50: "#fff",
                                  neutral80: "#9da7b5",
                                },
                              })}
    
                            />
                                                      </span>
                                            </div>
                                            
                                            </td>
                                            </tr>
                                            
                                            
                                            <tr><td>
                                           
                                            <div style={{}}>
                                                <span style={{marginTop:'5px'}}>
                                                {this.state.tagsShow ?
                                                   <div style={{ height:'100px',  overflowY:'scroll'}}>
    
                                                       {
                                                           this.tableHeadDataShow()}
                                                   </div>
                                                   :
                                                   <Spinner
                                                       size={SpinnerSize.small}
                                                       label="Loading Tags"
                                                       ariaLive="off"
                                                       labelPosition="bottom"
                                                   />}
                                                    
                                                    </span> &nbsp; &nbsp; 
                                                 
                                                    </div>
                                            
                                            </td></tr>
                                            
                                            </table> 
                              
                              
                                    <div className="editor-page-content-main1" style={{marginTop:'-2%'}} >
                                    

                                        {selectedAsset ?
                                            <div className="editor-page-content-main-body1"  style={{marginTop:'1%', height:'1000px',  overflowY:'scroll'}}  onClick={this.onPageContainerClick}>

                                                {

                                                    selectedAsset && this.state.selectedDType.value=='email'?
                                                    // <div id="demo"></div>
                                                    <iframe srcDoc={this.state.resp} style={{width:'100%', background:'white', height:'600px', overflowY:'scroll',}}></iframe>
                                                    :  this.state.selectedDType.value=='attachment' &&  finalImageUrl ==""? 
                                                     <iframe srcDoc="<html><body> No Attachments </body></html>" 
                                                     style={{width:'100%', height:'600px', overflowY:'scroll', background:'white'}}></iframe>:
                                                     
                                                     this.state.selectedDType.value=='attachment' &&  isExcel? 
                                                   <>       
                                                        <DocViewer source={this.state.aresp}/>
                                                        
                                                       </>
     
                                                    
                                                     :
                                                     <div  style={{width:'100%', height:'600px', overflowY:'scroll', background:'white'}}>
                                                    <Canvas
                                                        ref={this.canvas}
                                                        selectedAsset={this.state.selectedAsset}
                                                        onAssetMetadataChanged={this.onAssetMetadataChanged}
                                                        onCanvasRendered={this.onCanvasRendered}
                                                        onSelectedRegionsChanged={this.onSelectedRegionsChanged}
                                                        onRunningOCRStatusChanged={this.onCanvasRunningOCRStatusChanged}
                                                        onRunningAutoLabelingStatusChanged={this.onCanvasRunningAutoLabelingStatusChanged}
                                                        onTagChanged={this.onTagChanged}
                                                        onAssetDeleted={this.confirmDocumentDeleted}
                                                        editorMode={this.state.editorMode}
                                                        project={this.state.project}
                                                        lockedTags={this.state.lockedTags}
                                                        hoveredLabel={this.state.hoveredLabel}
                                                        setTableToView={this.setTableToView}
                                                        closeTableView={this.closeTableView}
                                                        runOcrForAllDocs={this.loadOcrForNotVisited}
                                                        appSettings={this.props.appSettings}
                                                    // selectedOcrFile={selectedOcrFile}
                                                    >
                                                        <AssetPreview
                                                            controlsEnabled={this.state.isValid}
                                                            onBeforeAssetChanged={this.onBeforeAssetSelected}
                                                            asset={this.state.selectedAsset.asset} />
                                                    </Canvas>
                                                    </div>
                                                }
                                            </div>
                                            : <Spinner
                                                size={SpinnerSize.large}
                                                label="Loading file to preview"
                                                ariaLive="off"
                                                className="mt-5"
                                                labelPosition="bottom"
                                            />
                                        }    
                                    </div> </div>                                     
                                    <div id="mPanel">&nbsp;</div></div>
                                    </div>}
          right={<div style={{ margin: "1rem" }}>   
           <div id="rPanel">
{   
    this.state.tagsShow ?
                                                <div style={{}}>
                                                    {
                                                        this.tableDataShow()}
                                                </div>
                                                :
                                                <Spinner
                                                    size={SpinnerSize.small}
                                                    label="Loading Tags"
                                                    ariaLive="off"
                                                    labelPosition="bottom"
                                                />
                                        }
                                        <Confirm
                                            title={strings.editorPage.tags.rename.title}
                                            ref={this.renameTagConfirm}
                                            message={strings.editorPage.tags.rename.confirmation}
                                            confirmButtonTheme={getPrimaryRedTheme()}
                                            onCancel={this.onTagRenameCanceled}
                                            onConfirm={this.onTagRenamed}
                                        />
                                        <Confirm
                                            title={strings.editorPage.tags.delete.title}
                                            ref={this.deleteTagConfirm}
                                            message={strings.editorPage.tags.delete.confirmation}
                                            confirmButtonTheme={getPrimaryRedTheme()}
                                            onConfirm={this.onTagDeleted}
                                        />
                                        {this.state.selectedAsset &&
                                            <Confirm
                                                title={strings.editorPage.asset.delete.title}
                                                ref={this.deleteDocumentConfirm}
                                                message={
                                                    strings.editorPage.asset.delete.confirmation +
                                                    "\"" + this.state.selectedAsset.asset.name + "\"?"
                                                }
                                                confirmButtonTheme={getPrimaryRedTheme()}
                                                onConfirm={this.onAssetDeleted}
                                            />
                                        }
                                   </div>         
                                    
         </div>}
         />
         </div>
   {/*   </SplitPane>*/}
 </div>

                            <Alert
                                show={this.state.showInvalidRegionWarning}
                                title={strings.editorPage.messages.enforceTaggedRegions.title}
                                // tslint:disable-next-line:max-line-length
                                message={strings.editorPage.messages.enforceTaggedRegions.description}
                                onClose={() => this.setState({ showInvalidRegionWarning: false })}
                            />
                            <Alert
                                show={this.state.isError}
                                title={this.state.errorTitle || "Error"}
                                message={this.state.errorMessage}
                                onClose={() => this.setState({
                                    isError: false,
                                    errorTitle: undefined,
                                    errorMessage: undefined,
                                })}
                            />
                            <PreventLeaving
                                when={isRunningOCRs || isCanvasRunningOCR}
                                message={"An OCR operation is currently in progress, are you sure you want to leave?"}
                            />
                            <PreventLeaving
                                when={isCanvasRunningAutoLabeling}
                                message={"An AutoLabeling option is currently in progress, are you sure you want to leave?"} />

                            <SkipButton skipTo="pageEditor">{strings.common.skipToMainContent}</SkipButton>

                      {/*  </BeforeUnloadComponent> */}
                    </div>

                    <StatusBar>
                        <StatusBarMetrics project={this.props.project} />
                    </StatusBar>

                </>
            );
        


        //const { selectedOcrFile} = this.state;
        // const showTable = size(columnNames) > 0 ? true : false;

    }

    // call function from child
    private onPageContainerClick = () => {
        // workaround: tagInput will not lost focus with olmap,
        // so we fire the blur event manually here
        // this.tagInputRef.current.triggerNewTagBlur();
    }
    handleChange(event) {
        this.setState({ selectedProject: event.target.value });
        // this.selectedProject = event.target.value;
        console.log("@@@@@@@@@", this.selectedProject)

    }

    // tslint:disable-next-line:no-empty
    private onPageClick = () => {
    }

     
    public tableHeadDataShow = () => {
        const { tagsInfo } = this.state;
        let statusOptions = [];
        let HeadData=[];
        let OHeadData=[];
        let reqLength = JSON.parse(localStorage.getItem("reqLength"))
        
        this.state.tableHeaders && this.state.tableHeaders.map((model, index) => {
           if(model.key==="MailSubject"||
            model.key==="MailTo"||
            model.key==="Mail_CC"||
            model.key==="Customer_email_address"||
            model.key==="Email_Sent_Date"
            )
            {
                HeadData.push(model);
            }
            else
            {
                OHeadData.push(model);
            }
        });         
        
                
        return (
            <div>
                <div  >
                    <table style={{width:'200%'}}  >
                        <thead>
                          {/*   <tr>
                                <th style={{width:'100%'}}>tag Name</th>
                                <th  style={{width:'100%'}}>tag Value</th>
                            </tr>
                            */}
                        </thead>
                        
                        <tbody>

                        {HeadData && HeadData.map((model, index) => {
                            
                            
                            let iseMailHead=false;
                            
                            iseMailHead = model.key==="MailSubject"||
                            model.key==="MailTo"||
                            model.key==="Mail_CC"||
                            model.key==="Customer_email_address"||
                            model.key==="Email_Sent_Date" ? true:false
                            
                           
                return (
                    
                        iseMailHead?
                    <tr  >
                        <td  style={{width:'10%'}} > <div style={{ color:'#f3cb40'}} > {model.key} </div></td>
                        
                      <td  >
                      <div className= "">{model.value}  </div>         
                                       </td>
                                       
                                       
                
                    </tr>
                    :
                                       <></>
                )})}

                       

                        </tbody>

                    </table>
                    

                     

                   
                   
                    <br>
                    </br>
                </div>

            </div>
        );

    }

  
    public tableDataShow = () => {
        const { tagsInfo } = this.state;
        let statusOptions = []
        let reqLength = JSON.parse(localStorage.getItem("reqLength"))
        if(reqLength!=null){
            if(Number(reqLength)> 1){
                        statusOptions = [
                          //  { value: 'Success', label: 'Success' },
                          //  { value: 'Exception', label: 'Exception' },
                          { value: 'Completed', label: 'Completed' },
                            { value: 'Not Started', label: 'Not Started' },
                            { value: 'Not Started-Exception', label: 'Not Started-Exception' },
                            { value:'No Action Required' , label:'No Action Required'}
                        ];
                    }
                    else{
                        statusOptions = [
                            { value: 'Success', label: 'Success' },
                            { value: 'Completed', label: 'Completed' },
                          //  { value: 'Exception', label: 'Exception' },
                            { value: 'Not Started', label: 'Not Started' },
                            { value: 'Not Started-Exception', label: 'Not Started-Exception' },
                            { value:'No Action Required' , label:'No Action Required'}
                        ];
                    }
        }
        
        return (
            <div>
                <div className="card wrap-body-my_models shadow model-data mt-2">
                    <table className="table table-dark table-striped">
                        <thead>
                            <tr>
                                <th style={{width:'50%'}}>Tag Name</th>
                                <th  style={{width:'50%'}}>Tag Value</th>
                            </tr>
                        </thead>
                        <tbody>

                        {this.state.tableHeaders && this.state.tableHeaders.map((model, index) => {
                            let isDisabled = false

                            isDisabled = model.key==="PartitionKey"||
                            model.key==="RowKey"||
                            model.key==="Timestamp"||
                            model.key==="APIResponse"||
                            model.key==="RequestDetailsID"||
                            model.key==="Email_Sent_Date"||
                            model.key==="Customer_email_address"||
                            model.key==="MailSubject"||
                            model.key==="MailTo"||
                            model.key==="Mail_CC" ? true:false

                            let dropSelVal =  { value: model.value, label: model.value };
                            let eRec= (model.value==="Exception" || (model.key==="Material"&&model.value=="9999"))?true:false;
                           
                            let iseMailHead=false;
                            
                            iseMailHead = model.key==="MailSubject"||
                            model.key==="MailTo"||
                            model.key==="Mail_CC"||
                            model.key==="Email_Sent_Date"||
                            model.key==="Customer_email_address" ? true:false
                return (
                    iseMailHead?<></>:
                    <tr >
                        <td > <div className= {eRec?"bgRed":""}> {model.key} </div></td>
                        
                       { model.key==="Status"?
                        
                        <td>
                            
                            <Select options={statusOptions}
                                            value={dropSelVal}                                          
                                            onChange={e => this.ondChange(e, index)}
                                            className="react-select-container z-index-19"
                                            isClearable={true}
                                            theme={(theme) => ({
                                                ...theme,
                                                colors: {
                                                    ...theme.colors,
                                                    primary25: "#161a1f",
                                                    primary: "#6b727d",
                                                    neutral0: "#222830",
                                                    neutral20: "#44474c",
                                                    neutral30: "#272c33",
                                                    neutral50: "#fff",
                                                    neutral80: "#9da7b5",
                                                },
                                            })}

                                        />
                                       
                                       </td>
                                       :
                                       iseMailHead?<></>:
                                       model.key !== "ReqDateH" ? 
                                       <td >
                                         { this.getFieldData_DM(model,index,eRec,isDisabled)}                                        
                                               
                                              
                                       
                                       </td>
                                       
                                       :
                                       <td>
                                           <div className="edit-calendar">

                                           <input
                                                className={eRec?"form-control bgRed editCalendar":"form-control editCalendar"}
                                                id="af_ToDate"
                                                value={moment(model.value).format("YYYY-MM-DD")}
                                                type="date"
                                                data-date={model.value=="Exception"?"Exception":moment(model.value).format("MM/DD/YYYY")}
                                                data-date-format="MM/DD/YYYY"
                                                onChange={(e) => this.onChange(e,index)} name="createModel" /> 
                                           </div>   
                                       </td>
                                       
                }
                    </tr>
                )})}

                       

                        </tbody>

                    </table>
                     {/* <br></br>

{this.state.customer == "JETBLUE" ? <div>
                        <table className="table table-dark table-striped">
                            <thead>
                            {this.state.tagsInfo.table.length !=0?
                                <tr>

                                    <th>a
                                    Reference
                                    </th>
                                    <th>
                                    Designation
                                    </th>


                               
                           
                             </tr>:''
    }
                            </thead>
                            <tbody>

                            {this.state.tagsInfo.table && this.state.tagsInfo.table.map((model, index) => {
                                    return (
                                        <tr>
                                            <td>
                                                {model.Reference}
                                            </td>
                                            <td>
                                                {model.Designation}
                                            </td>
                                        </tr>

                                    )})}
                            </tbody>
                        </table>
                    </div>: this.state.customer == "FEDEX" ? <div>
                        <table className="table table-dark table-striped">
                            <thead>
                            {this.state.tagsInfo.table.length !=0?
                                <tr>

                                    <th>
                                    Zone
                                    </th>
                                    <th>
                                    Description
                                    </th>

                               
                           
                             </tr>:''}
                            </thead>
                            <tbody>

                            {this.state.tagsInfo.table && this.state.tagsInfo.table.map((model, index) => {
                                    return (
                                        <tr>
                                            <td>
                                                {model.Zone}
                                            </td>
                                            <td>
                                                {model.Description}
                                            </td>
                                        </tr>

                                    )})}
                            </tbody>
                        </table>
                    </div>:<div></div>}  */}

{/* <table className="table table-dark table-striped">
                         <thead>
                             <tr>
                                 {this.state.associationHeader && this.state.associationHeader.sort().map((element,index)=>{
                                  return ( 
                                      
                                      <th style={{width:'1000px'}}>
                                         {element == 'TargetQty' ? 'Quantity':element}
                                     </th>

                                  ) })
                                }
                             </tr>
                         </thead>
                         <tbody>

                        {this.state.tagsInfo.table && this.state.tagsInfo.table.sort().map((model, index) => {
                return (
                    
                    <tr>

                                 {this.state.associationHeader && this.state.associationHeader.map((element,index1)=>{
                                    
                                  return (
                                      <td>
                                          {model[element]}
                                      </td> 
                                      
                                    // <td> <input type="text" id="tag_val" name="tag_val" value={model[element]} style={{ height: '34px', background: 'black', color: 'white', borderRadius: '2px', border: '1px', width:'100%' }}
                                    // onChange={e => this.AssociationChange(e, index)} /></td>

                                  ) })
                                }
                               
                       
                        
                    </tr>
                )})}

                       

                        </tbody>
                     </table> */}

                    <div className="text-center mt-5" >
                        <button

                            onClick={() => this.back()}
                            className="btn-custom">
                             Back
                                            </button> &nbsp; 
                                          
                                            <button

onClick={() => this.exceptionReviewData()}
className="btn-custom">
 Exception
                </button> &nbsp; 
                                      {/*         
                                            
                                            <button

onClick={() => this.back()}
className="btn-custom">
<i className="fa fa-code " aria-hidden="true"></i> Process
                </button> &nbsp;*/}
                 <button 

onClick={() => this.submitReviewData()}
className="btn-custom">
  Submit
                </button>
                    </div>

                   
                   
                    <br>
                    </br>
                </div>

            </div>
        );

    }
    
    public getFieldData_DM = (model,index,eRec,isDisabled) => {
        console.log(model.key)
         const transactionOptions = [
            { value: 'Z1AA', label: 'Z1AA' },
            { value: 'Z1BA', label: 'Z1BA' }
        ]
        const shippingOptions = [
            { value: 'Z1', label: 'Z1' },
            { value: 'Z2', label: 'Z2' }
        ]
        let dropSelVal =  { value: model.value, label: model.value };
        
        return (
         model.key==="OrderType"?
          
            <Select options={transactionOptions}
                    value={dropSelVal}                                          
                    onChange={e => this.ondChange(e, index)}
                  //  className="react-select-container z-index-19"
                    isClearable={true}
                    theme={(theme) => ({
                        ...theme,
                        colors: {
                            ...theme.colors,
                            primary25: "#161a1f",
                            primary: "#6b727d",
                            neutral0: "#222830",
                            neutral20: "#44474c",
                            neutral30: "#272c33",
                            neutral50: "#fff",
                            neutral80: "#9da7b5",
                        },
                    })}

        />
        :
        model.key==="ShippingCond"?
           
           <Select options={shippingOptions}
                    value={dropSelVal}                                          
                    onChange={e => this.ondChange(e, index)}
                 //   className="react-select-container z-index-19"
                    isClearable={true}
                    theme={(theme) => ({
                        ...theme,
                        colors: {
                            ...theme.colors,
                            primary25: "#161a1f",
                            primary: "#6b727d",
                            neutral0: "#222830",
                            neutral20: "#44474c",
                            neutral30: "#272c33",
                            neutral50: "#fff",
                            neutral80: "#9da7b5",
                        },
                    })}

        />
        : 
            <input  className= {eRec?"bgRed":""} type="text" id="tag_val"
            name="tag_val" value={model.value} style={{ height: '34px',
            background: 'black', color: 'white', borderRadius: '2px', 
            border: '1px', width:'100%', opacity: isDisabled?'0.4':'' }}
      onChange={e => this.onChange(e, index)} 
      disabled={isDisabled}/>
        );
       
    }

    /**
     * Called when the asset side bar is resized
     * @param newWidth The new sidebar width
     */
    private onSideBarResize = (newWidth: number) => {
        this.setState({
            thumbnailSize: {
                width: newWidth,
                height: newWidth / (4 / 3),
            },
        });
        this.resizeCanvas()
    }




    private editTagData = async (data, index) => {
        const tagsInfo = [...this.state.tagsInfo];
        tagsInfo[index].isEditClicked = true;
        this.setState({ tagsInfo: tagsInfo, newTagValue: tagsInfo[index].tagValue });

    }



    private saveTagData = async (data, index) => {
        const tagsInfo = [...this.state.tagsInfo];
        tagsInfo[index].isUpdated = true;
        tagsInfo[index].isEditClicked = false;
        tagsInfo[index].tagValue = this.state.newTagValue;

        this.setState({ tagsInfo: tagsInfo, newTagValue: "" });

    }


    private cancelTagData = async (data, index) => {
        const tagsInfo = [...this.state.tagsInfo];
        tagsInfo[index].isUpdated = false;
        tagsInfo[index].isEditClicked = false;
        this.setState({ tagsInfo: tagsInfo });

    }

    private getInputValues = (event) => {

        if (event.target.value) {
            this.setState({ newTagValue: event.target.value });
        }
    }

    public getExceptionTagsInfo()
    {              
       let tsglist=[];
       this.state.tableHeaders.forEach(element=>{
           if(element.value === "Exception")
           {
               tsglist.push(element.key);
           }  
           if(element.key === "Material")    
           {
            if(element.value === "9999")  
            {
                tsglist.push(element.key);
            }
           }       
       });       
       this.setState({ exceptionKeyList: tsglist });  
       return   tsglist;   
    }
    
    
    public exceptionReviewData = async () => {
        
        let exceptionList= this.getExceptionTagsInfo();
        this.setState({tagsShow:false})
        let object ={}
        this.state.tableHeaders.forEach(element=>{
            if(element.key=="ReqDateH"&&element.value!="Exception"){
                var momentString = moment(element.value).format('MM/DD/YYYY'); 
                object[element.key] =  momentString
            }
            else{
                object[element.key] = element.value
            }
        });
        
        let selectedDocument = JSON.parse(localStorage.getItem("selectedDocument"));
        object['Body_SAS_Url']= selectedDocument['Body_SAS_Url'];
        object['Attachment_SAS_Url']= selectedDocument['Attachment_SAS_Url'];

       let body = {
        exceptionKeyList:exceptionList
        };
        console.log("body",body);        
        const endpointURL = documentMangementTagsException(selectedDocument['RowKey'], selectedDocument['RequestDetailsID']);
        const headers = accessToken();
        axios( endpointURL , { method: "POST" , data: body, headers}).
        then((resp) => {
           // debugger;
          if (resp.status === 200 || resp.status === 201) {
            this.setState({tagsShow:true})
            toast.success("Exception Tags updated Sucessfully!", { position: toast.POSITION.TOP_CENTER });            
            if(resp.data.toLocaleLowerCase()==="mail not sent!")
            {
            toast.error(resp.data, { position: toast.POSITION.TOP_CENTER });
            }
            else
            {
                toast.success(resp.data, { position: toast.POSITION.TOP_CENTER });
            }
            // toast.success(resp.data, { position: toast.POSITION.TOP_CENTER });
            
          }
        })
    }


    private submitReviewData = async () => {
        this.setState({tagsShow:false})
        let object ={}
        this.state.tableHeaders.forEach(element=>{
            if(element.key=="ReqDateH"&&element.value!="Exception"){
                var momentString = moment(element.value).format('MM/DD/YYYY'); 
                object[element.key] =  momentString
            }
            else if(element.key==="ShipTo" )
            {
                
                object[element.key] = element.value.trim();
            }
            else if(element.key==="Preloaded_Transporter_Notes" )
            {
                 
                object[element.key] = element.value.trim();
            }
            else{
                object[element.key] = element.value
            }
            
        })
        let selectedDocument = JSON.parse(localStorage.getItem("selectedDocument"));
        object['Body_SAS_Url']= selectedDocument['Body_SAS_Url']
        object['Attachment_SAS_Url']= selectedDocument['Attachment_SAS_Url']

       let body = {
        json_output:object
        }
        console.log("body",body);
        debugger;

        const endpointURL = documentMangementTagsSave(selectedDocument['RequestDetailsID']);
        const headers = accessToken();
        axios( endpointURL , { method: "POST" , data: body, headers}).
        then((resp) => {
          if (resp.status === 200 || resp.status === 201) {
            this.setState({tagsShow:true})
            toast.success("Tags updated Sucessfully", { position: toast.POSITION.TOP_CENTER });
          }
        })
    }






    /**
     * Called when the asset sidebar has been completed
     */
    private onSideBarResizeComplete = () => {
        const appSettings = {
            ...this.props.appSettings,
            thumbnailSize: this.state.thumbnailSize,
        };

        this.props.applicationActions.saveAppSettings(appSettings);
    }

    /**
     * Called when a tag from footer is clicked
     * @param tag Tag clicked
     */
    private onTagClicked = (tag: ITag): void => {
        this.setState({
            selectedTag: tag.name,
            lockedTags: [],
        }, () => this.canvas.current.applyTag(tag.name));
    }

    /**
     * Open confirm dialog for tag renaming
     */
    private confirmTagRename = (tag: ITag, newTag: ITag, cancelCallback: () => void): void => {
        this.renameCanceled = cancelCallback;
        this.renameTagConfirm.current.open(tag, newTag);
    }

    /**
     * Renames tag in assets and project, and saves files
     * @param tag Tag to be renamed
     * @param newTag Tag with the new name
     */
    private onTagRenamed = async (tag: ITag, newTag: ITag): Promise<void> => {
        this.renameCanceled = null;
        const assetUpdates = await this.props.actions.updateProjectTag(this.props.project, tag, newTag);
        const selectedAsset = assetUpdates.find((am) => am.asset.id === this.state.selectedAsset.asset.id);

        if (selectedAsset) {
            if (selectedAsset) {
                this.setState({ selectedAsset });
            }
        }
    }

    private onTagRenameCanceled = () => {
        if (this.renameCanceled) {
            this.renameCanceled();
            this.renameCanceled = null;
        }
    }

    /**
     * Open Confirm dialog for tag deletion
     */
    private confirmTagDeleted = (tagName: string): void => {
        this.deleteTagConfirm.current.open(tagName);
    }

    /**
     * Open Confirm dialog for document deletion
     */
    private confirmDocumentDeleted = (): void => {
        this.deleteDocumentConfirm.current.open();
    }

    /**
     * Removes tag from assets and projects and saves files
     * @param tagName Name of tag to be deleted
     */
    private onTagDeleted = async (tagName: string): Promise<void> => {
        const assetUpdates = await this.props.actions.deleteProjectTag(this.props.project, tagName);

        const selectedAsset = assetUpdates.find((am) => am.asset.id === this.state.selectedAsset.asset.id);
        if (selectedAsset) {
            this.setState({ selectedAsset });
        }
    }

    private onCtrlTagClicked = (tag: ITag): void => {
        const locked = this.state.lockedTags;
        this.setState({
            selectedTag: tag.name,
            lockedTags: CanvasHelpers.toggleTag(locked, tag.name),
        }, () => this.canvas.current.applyTag(tag.name));
    }

    private getTagFromKeyboardEvent = (event: KeyboardEvent): ITag => {
        const index = tagIndexKeys.indexOf(event.key);
        const tags = this.props.project.tags;
        if (index >= 0 && index < tags.length) {
            return tags[index];
        }
        return null;
    }

    /**
     * Listens for {number key} and calls `onTagClicked` with tag corresponding to that number
     * @param event KeyDown event
     */
    private handleTagHotKey = (event: KeyboardEvent): void => {
        const tag = this.getTagFromKeyboardEvent(event);
        const selection = this.canvas.current.getSelectedRegions();

        if (tag && selection.length) {
            const { format, type, documentCount, name } = tag;
            const tagCategory = this.tagInputRef.current.getTagCategory(tag.type);
            const category = selection[0].category;
            const labels = this.state.selectedAsset.labelData.labels;
            const isTagLabelTypeDrawnRegion = this.tagInputRef.current.labelAssignedDrawnRegion(labels, tag.name);
            const labelAssigned = this.tagInputRef.current.labelAssigned(labels, name);

            if (labelAssigned && ((category === FeatureCategory.DrawnRegion) !== isTagLabelTypeDrawnRegion)) {
                if (isTagLabelTypeDrawnRegion) {
                    toast.warn(interpolate(strings.tags.warnings.notCompatibleWithDrawnRegionTag, { otherCatagory: category }));
                } else if (tagCategory === FeatureCategory.Checkbox) {
                    toast.warn(interpolate(strings.tags.warnings.notCompatibleWithDrawnRegionTag, { otherCatagory: FeatureCategory.Checkbox }));
                } else {
                    toast.warn(interpolate(strings.tags.warnings.notCompatibleWithDrawnRegionTag, { otherCatagory: FeatureCategory.Text }));
                }
                return;
            } else if (tagCategory === category || category === FeatureCategory.DrawnRegion ||
                (documentCount === 0 && type === FieldType.String && format === FieldFormat.NotSpecified)) {
                if (tagCategory === FeatureCategory.Checkbox && labelAssigned) {
                    toast.warn(strings.tags.warnings.checkboxPerTagLimit);
                    return;
                }
                this.onTagClicked(tag);
            } else {
                toast.warn(strings.tags.warnings.notCompatibleTagType, { autoClose: 7000 });
            }
        }
        // do nothing if region was not selected
    }

    /**
     * Returns a value indicating whether the current asset is taggable
     */
    private isTaggableAssetType = (asset: IAsset): boolean => {
        return asset.type !== AssetType.Unknown;
    }

    /**
     * Raised when the selected asset has been changed.
     * This can either be a parent or child asset
     */
    private onAssetMetadataChanged = async (assetMetadata: IAssetMetadata): Promise<void> => {
        // Comment out below code as we allow regions without tags, it would make labeler's work easier.

        const initialState = assetMetadata.asset.state;

        const asset = { ...assetMetadata.asset };

        if (this.isTaggableAssetType(assetMetadata.asset)) {
            assetMetadata.asset.state = _.get(assetMetadata, "labelData.labels.length", 0) > 0 ?
                AssetState.Tagged :
                AssetState.Visited;
        } else if (assetMetadata.asset.state === AssetState.NotVisited) {
            assetMetadata.asset.state = AssetState.Visited;
        }

        // Only update asset metadata if state changes or is different
        if (initialState !== assetMetadata.asset.state || this.state.selectedAsset !== assetMetadata) {
            if (this.state.selectedAsset.labelData && this.state.selectedAsset.labelData.labels &&
                assetMetadata.labelData && assetMetadata.labelData.labels &&
                assetMetadata.labelData.labels.toString() !== this.state.selectedAsset.labelData.labels.toString()) {
                await this.updatedAssetMetadata(assetMetadata);
            }
            await this.props.actions.saveAssetMetadata(this.state.project, assetMetadata);
            if (this.state.project.lastVisitedAssetId === assetMetadata.asset.id) {
                this.setState({ selectedAsset: assetMetadata });
            }
        }

        // Find and update the root asset in the internal state
        // This forces the root assets that are displayed in the sidebar to
        // accurately show their correct state (not-visited, visited or tagged)
        const assets = [...this.state.assets];
        const assetIndex = assets.findIndex((a) => a.id === asset.id);
        if (assetIndex > -1) {
            assets[assetIndex] = {
                ...asset,
            };
        }

        this.setState({ assets, isValid: true });

        // Workaround for if component is unmounted
        if (!this.isUnmount) {
            this.props.appTitleActions.setTitle(`${this.state.project.name} - [ ${asset.name} ]`);
        }
    }

    private onAssetLoaded = (asset: IAsset, contentSource: ContentSource) => {
        const assets = [...this.state.assets];
        const assetIndex = assets.findIndex((item) => item.id === asset.id);
        if (assetIndex > -1) {
            const assets = [...this.state.assets];
            const item = { ...assets[assetIndex] };
            item.cachedImage = (contentSource as HTMLImageElement).src;
            assets[assetIndex] = item;
            this.setState({ assets });
        }
    }

    /**
     * Raised when the asset binary has been painted onto the canvas tools rendering canvas
     */
    private onCanvasRendered = async (canvas: HTMLCanvasElement) => {
        // When active learning auto-detect is enabled
        // run predictions when asset changes
    }

    private onSelectedRegionsChanged = (selectedRegions: IRegion[]) => {
        this.setState({ selectedRegions });
    }

    private onTagsChanged = async (tags) => {
        const project = {
            ...this.props.project,
            tags,
        };
        await this.props.actions.saveProject(project, true, false);
    }

    private onLockedTagsChanged = (lockedTags: string[]) => {
        this.setState({ lockedTags });
    }

    private onBeforeAssetSelected = (): boolean => {
        if (!this.state.isValid) {
            this.setState({ showInvalidRegionWarning: true });
        }


        return this.state.isValid;
    }

    private selectAsset = async (asset: IAsset): Promise<void> => {
        // Nothing to do if we are already on the same asset.
        if (this.state.selectedAsset && this.state.selectedAsset.asset.id === asset.id) {
            return;
        }

        if (!this.state.isValid) {
            this.setState({ showInvalidRegionWarning: true });
            return;
        }
        if (this.state.isCanvasRunningAutoLabeling) {
            return;
        }

        //

        const projectname = "invoice_w_po_D";
        const connection = { id: null, name: null, providerType: "azureBlobStorage", providerOptions: {} };
        connection.providerOptions["sas"] = IAzureFields.sasUrl;

        const project: IProject = {
            id: "",
            name: projectname,
            version: "",
            securityToken: "token",
            tags: [],
            sourceConnection: connection,
            lastVisitedAssetId: "",
            tableTags: [],
            fromModel: true,
            apiUriBase: IAzureFields.endPoint,
            apiKey: IAzureFields.key,
            folderPath: `${projectname}-${this.state.userId}}/training`,
            projType: "ocr", //model.type.toLocaleLowerCase(),
            assets: {},
            predictModelId: "",
            analyzeResult: [],
            exportFormat: null,
            activeLearningSettings: null,
            autoSave: false,
            targetConnection: null,
            videoSettings: null,
            isProjectExported: false,
            isProjectSaved: false,
        };
        //
        const assetMetadata = await this.props.actions.loadAssetMetadata(project, asset);
        // const assetMetadata = await this.props.actions.loadAssetMetadata(this.props.project, asset);
        //console.log("metadata==>"+JSON.stringify(assetMetadata));
/*
        if (assetMetadata.labelData) {
            const alllabels = assetMetadata.labelData.labels;
            const tagsInfo = [];
            alllabels.forEach(async (element: any) => {
                const labelname = element.label;
                const labelval = element.value[0].text;
                const tagData = {
                    tagName: labelname,
                    tagValue: labelval,
                    isUpdated: false,
                    isEditClicked: false,

                }
                tagsInfo.push(tagData);

            });
            // this.setState({ tagsInfo: tagsInfo });

        }
        
        */
        try {
            if (!assetMetadata.asset.size) {
                const assetProps = await HtmlFileReader.readAssetAttributes(asset);
                assetMetadata.asset.size = { width: assetProps.width, height: assetProps.height };
            }
        } catch (err) {
            console.warn("Error computing asset size");
        }

        this.setState({
            selectedOcrFile: null,
            tableToView: null,
            tableToViewId: null,
            selectedAsset: assetMetadata,
        }, async () => {
            // await this.onAssetMetadataChanged(assetMetadata);
            //  await this.props.actions.saveProject(this.props.project, false, false);
        });
    }

    onChange =(event, index) =>{ 
       // debugger;
        console.log(event.target);
        const { key, value } = event.target;
        this.setState(previousState => {
          const tableHeaders = [...previousState.tableHeaders];
          tableHeaders[index] = { ...tableHeaders[index],value:value};
          return { tableHeaders };
        });
      };
      
      ondChange_old =(event, index) =>{ 
        //debugger;
        console.log(event);
        const { key, value } = event;
        this.setState(previousState => {
          const tableHeaders = [...previousState.tableHeaders];
          tableHeaders[index] = { ...tableHeaders[index],value:value};
          return { tableHeaders };
        });
      };
      
      ondChange =(event, index) =>{ 
       // debugger;
        console.log(event);
        let allowModification = true;
        //
        this.state.tableHeaders.forEach(element=>{            
            let isExceptionFeild = false;  
            isExceptionFeild = (element.key==="ShipTo"||element.key==="ReqDateH"||element.key==="Material"||
            element.key==="Plant"||element.key==="Quantity")?true:false;                             
            if(isExceptionFeild&&element.value ==="Exception"){
                allowModification =false;
            }
        });
            
       
        if(!allowModification && event && event.value==="Success" )
        {
            //do not modify the status
            toast.error("Clear Exception before selecting 'Success' status!", { position: toast.POSITION.TOP_CENTER });
        }
        else if(event)
        {
        const { key, value } = event;
        this.setState(previousState => {
          const tableHeaders = [...previousState.tableHeaders];
          tableHeaders[index] = { ...tableHeaders[index],value:value};
          return { tableHeaders };
        });
        }        
      };
      
      
    back(){
        localStorage.setItem("DocMgtBack", "Y");
        this.props.history.push(`/DocumentManagement`);
       // this.props.history.goBack();
    }

    private loadProjectAssets_fr = async (): Promise<void> => {
        //debugger;
        if (this.loadingProjectAssets) {
            return;
        }

        this.loadingProjectAssets = true;

        try {

            // new changes start
            const projectCopy = Object.assign({}, this.props.project);
            projectCopy.folderPath = `${this.props.match.params["projectName"]}-${this.state.userId}/training`;
            await this.props.actions.saveProject(projectCopy, false, false);


            const assets = _(await this.props.actions.loadAssets(this.props.project))
                .uniqBy((asset) => asset.id)
                .value();

            // new changes end

            //  const assets = _(await this.props.actions.loadAssets(this.props.project))
            //     .uniqBy((asset) => asset.id)
            //    .value();


            if (this.state.assets.length === assets.length
                && JSON.stringify(this.state.assets) === JSON.stringify(assets)) {
                this.loadingProjectAssets = false;
                this.setState({ tagsLoaded: true });
                return;
            }

            const lastVisited = assets.find((asset) => asset.id === this.props.project.lastVisitedAssetId);

            this.setState({
                assets,
            }, async () => {
                await this.props.actions.saveProject(this.props.project, false, true);
                this.setState({ tagsLoaded: true });
                if (assets.length > 0) {
                    await this.selectAsset(lastVisited ? lastVisited : assets[0]);
                }
                this.loadingProjectAssets = false;
            });
        } catch (error) {
            throw Error(error);
        }
    }


    private loadProjectAssets = async (): Promise<void> => { 
        this.loadingProjectAssets = true;
        const rootAssets =[{
            format: "pdf",
id: "2e1d92d5d41a36362bf1fa9b3718166d1d12f24ef3026db8d55d4499872db16f",
labelData: null,
labelFilename: "invoice_w_po_D-2541c8e9-3e3e-418a-9e21-818657238210/training/APInvoice-SAP51065578142010-InvINV033935.pdf.labels.json",
name: "invoice_w_po_D-2541c8e9-3e3e-418a-9e21-818657238210/training/APInvoice-SAP51065578142010-InvINV033935.pdf",
ocrContent:{},
path:this.getPdfurl(),
size: null,
state: 2,
type: 5
        }]
        this.setState({
            assets: rootAssets,
        });
        if (rootAssets.length > 0) {
            await this.selectAsset(rootAssets[0]);
        }
        this.loadingProjectAssets = false;
    }
    private isBusy = (): boolean => {
        return this.state.isRunningOCRs || this.state.isCanvasRunningOCR || this.state.isCanvasRunningAutoLabeling;
    }
    public loadOcrForNotVisited = async (runForAll?: boolean) => {
        if (this.isBusy()) {
            return;
        }
        const { project } = this.props;
        const ocrService = new OCRService(project);
        if (this.state.assets) {
            this.setState({ isRunningOCRs: true });
            try {
                await throttle(
                    constants.maxConcurrentServiceRequests,
                    this.state.assets
                        .filter((asset) => runForAll ? asset : asset.state === AssetState.NotVisited)
                        .map((asset) => asset.id),
                    async (assetId) => {
                        // Get the latest version of asset.
                        const asset = this.state.assets.find((asset) => asset.id === assetId);
                        if (asset && (asset.state === AssetState.NotVisited || runForAll)) {
                            try {
                                this.updateAssetState(asset.id, true);
                                await ocrService.getRecognizedTextFR(asset.path, asset.name, undefined, runForAll);
                                //await ocrService.getRecognizedText(asset.path, asset.name, undefined, runForAll);
                                this.updateAssetState(asset.id, false, AssetState.Visited);
                            } catch (err) {
                                this.updateAssetState(asset.id, false);
                                this.setState({
                                    isError: true,
                                    errorTitle: err.title,
                                    errorMessage: err.message,
                                });
                            }
                        }
                    }
                );
            } finally {
                this.setState({ isRunningOCRs: false });
            }
        }
    }

    private updateAssetState = (id: string, isRunningOCR: boolean, assetState?: AssetState) => {
        this.setState((state) => ({
            assets: state.assets.map((asset) => {
                if (asset.id === id) {
                    const updatedAsset = { ...asset, isRunningOCR };
                    if (assetState !== undefined && asset.state === AssetState.NotVisited) {
                        updatedAsset.state = assetState;
                    }
                    return updatedAsset;
                } else {
                    return asset;
                }
            }),
        }), () => {
            if (this.state.selectedAsset && id === this.state.selectedAsset.asset.id) {
                const asset = this.state.assets.find((asset) => asset.id === id);
                if (asset) {
                    this.setState({
                        selectedAsset: { ...this.state.selectedAsset, asset: { ...asset } },
                    });
                }
            }
        });
    }

    /**
     * Updates the root asset list from the project assets
     */
    private updateAssetsState = () => {
        const updatedAssets = [...this.state.assets];
        let needUpdate = false;
        updatedAssets.forEach((asset) => {
            const projectAsset = _.get(this.props, "project.assets[asset.id]", null);
            if (projectAsset) {
                if (asset.state !== projectAsset.state) {
                    needUpdate = true;
                    asset.state = projectAsset.state;
                }
            }
        });

        if (needUpdate) {
            this.setState({ assets: updatedAssets });
        }
    }

    private onLabelEnter = (label: ILabel) => {
        this.setState({ hoveredLabel: label });
    }

    private onLabelLeave = (label: ILabel) => {
        this.setState({ hoveredLabel: null });
    }

    private onCanvasRunningOCRStatusChanged = (isCanvasRunningOCR: boolean) => {
        this.setState({ isCanvasRunningOCR });
    }
    private onCanvasRunningAutoLabelingStatusChanged = (isCanvasRunningAutoLabeling: boolean) => {
        this.setState({ isCanvasRunningAutoLabeling });
    }
    private onFocused = () => {
        this.loadProjectAssets();
    }

    private onAssetDeleted = () => {
        this.props.actions.deleteAssetFR(this.props.project, this.state.selectedAsset).then(() => {
            this.loadProjectAssets();
        });
    }

    private onTagChanged = async (oldTag: ITag, newTag: ITag) => {
        const assetUpdates = await this.props.actions.updateProjectTag(this.props.project, oldTag, newTag);
        const selectedAsset = assetUpdates.find((am) => am.asset.id === this.state.selectedAsset.asset.id);

        if (selectedAsset) {
            this.setState({
                selectedAsset,
            });
        }
    }

    private setTableToView = async (tableToView, tableToViewId) => {
        if (this.state.tableToViewId) {
            this.canvas.current.setTableState(this.state.tableToViewId, "rest");
        }
        this.canvas.current.setTableState(tableToViewId, "selected");
        this.setState({
            tableToView,
            tableToViewId,
        });
    }

    private handleTableViewClose = () => {
        this.closeTableView("rest");
    }

    private closeTableView = (state: string) => {
        if (this.state.tableToView) {
            this.canvas.current.setTableState(this.state.tableToViewId, state);
            this.setState({
                tableToView: null,
                tableToViewId: null,
            });
        }
    }

    private resizeCanvas = () => {
        if (this.canvas.current) {
            this.canvas.current.updateSize();
        }
    }

    private async updatedAssetMetadata(assetMetadata: IAssetMetadata) {
        const assetDocumentCountDifference = {};
        const updatedAssetLabels = {};
        const currentAssetLabels = {};
        assetMetadata.labelData.labels.forEach((label) => {
            updatedAssetLabels[label.label] = true;
        });
        this.state.selectedAsset.labelData.labels.forEach((label) => {
            currentAssetLabels[label.label] = true;
        });
        Object.keys(currentAssetLabels).forEach((label) => {
            if (!updatedAssetLabels[label]) {
                assetDocumentCountDifference[label] = -1;
            }
        });
        Object.keys(updatedAssetLabels).forEach((label) => {
            if (!currentAssetLabels[label]) {
                assetDocumentCountDifference[label] = 1;
            }
        });
        await this.props.actions.updatedAssetMetadata(this.props.project, assetDocumentCountDifference);
    }
}
